module.exports = __webpack_public_path__ + "static/media/UN-14.8cdf4449.jpg";